import React from "react";
import { PrestatriceTemplate } from "../../../components/templates";

function Prestatrices() {
  return <PrestatriceTemplate />;
}

export default Prestatrices;
